import { Link, useNavigate } from "react-router-dom";
import Back from "../../assets/icons/back.svg";
import { Card, Form, Input, InputNumber, message } from "antd";
import AddCard from "../../components/common/addcard";
import Checkbox from "../../components/common/checkBox";
import Button from "../../components/common/button";
import { useDispatch, useSelector } from "react-redux";
import VisaCard from "../../components/common/visaCard";
import MasterCard from "../../components/common/masterCard";
import { useEffect, useState } from "react";
import { deleteCard, fetchCardList } from "../../store/slices/paymentSlice";
import { addPaymentCard, updatePaymentCard } from "../../api/payment";
import { updatePersonalSettings } from "../../api/settings";
import Delete from "../../assets/icons/delete.svg";
import DeleteMemberModal from "../../components/common/modalMember";
import { fetchUsers, updateUserData, clearUserData } from "../../store/slices/userSlice";
import Dropdown from "../../components/common/dropdown";
import { UsaStates } from "usa-states";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";

const EditPaymentMethod = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const [selectedCard, setSelectedCard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCheckBox, setShowCheckBox] = useState(false);
  const [checkValue, setCheckValue] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selectedDiv, setSelectedDiv] = useState(null);

  const [loader, setLoader] = useState(false);
  const [bloader, setBloader] = useState(false);

  const cardData = useSelector((state) => state?.discount?.res);
  const deletedCard = useSelector((state) => state?.discount?.delete);
  const userData = useSelector((state) => state?.user);
  const usStates = new UsaStates();
  const showModal = () => {
    setIsModalOpen(true);
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchCardList());
      dispatch(fetchUsers());
    };
    fetchData();
  }, [deletedCard, dispatch]);

  const cardClickHandler = async (card) => {
    setSelectedCard(card);
    showModal();
  };
  const YesClickHandler = async () => {
    setIsModalOpen(false);
    try {
      dispatch(deleteCard(selectedCard?.id));
    } catch (error) {}
  };

  const onFinish = async (values) => {
    setLoader(true);
    if (!stripe || !elements) {
      return;
    }
    form.validateFields();
    const cardElementData = elements.getElement(CardNumberElement);
    const result = await stripe.createToken(cardElementData);
    if (result.error) {
      message.error(result?.error?.message);
      setLoader(false);
    } else {
      const payload = {
        card: {
          token: result.token.id,
        },
      };

      try {
        const res = await addPaymentCard(payload);
        if (res) {
          setLoader(true);
          message.success("Payment Successful");
          navigate("/main/payment-complete");
        }
      } catch (error) {
        message.error(error?.response?.data?.message);
      } finally {
        setLoader(false);
      }
    }
  };
  const handleForm = () => {
    setShowForm(true);
    setShowCheckBox(false);
  };
  const divCardHandler = (cardClick) => {
    setSelectedCard(cardClick);
    setSelectedDiv(cardClick.id);
    setShowCheckBox(true);
    setShowForm(false);
  };
  const primaryClickHandler = async () => {
    if (checkValue) {
      const res = await updatePaymentCard(selectedCard?.id);
      if (res) {
        message.success("Primary Card Updated");
      }
    } else {
      message.error("");
    }
  };

  const onBillingChange = async (values) => {
    const payload = {
      billingAddress: {
        streetAddress:
          values?.streetAddress ||
          userData?.response?.billingAddress?.streetAddress ||
          "",
        city: values?.city || userData?.response?.billingAddress?.city || "",
        zipCode:
          values?.zipCode?.toString() ||
          userData?.response?.billingAddress?.zipCode?.toString() ||
          "",
        state: values?.State || userData?.response?.billingAddress?.state || "",
      },
    };
    setBloader(true);
    try {
      const billRes = await updatePersonalSettings(payload);
      if (billRes) {
        message.success("Your Billing Address has been updated!");
        // Clear cached user data and fetch fresh data
        dispatch(clearUserData());
        const freshUserData = await dispatch(fetchUsers()).unwrap();
        // Force update the Redux state with fresh data
        dispatch(updateUserData(freshUserData));
      }
    } catch (e) {
      message.error(e);
    } finally {
      setBloader(false);
    }
  };
  return (
    <div className={`relative ${isModalOpen ? "blur-sm" : ""}`}>
      <div>
        <div className="flex pt-3 pl-3">
          <Link to="/main/profile">
            <div className="flex items-center">
              <img src={Back} alt="Edit Icon" className="mr-1" />
              <span className="text-lg font-bold text-black ml-1">
                Payment Method
              </span>
            </div>
          </Link>
        </div>
        <Card className="m-2 shadow-md">
          <p className="ml-2 text-primaryPurple font-medium flex sm:justify-start justify-center">
            Edit Payment Method
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center 2xl:grid-cols-5 sm:justify-start justify-center sm:items-start sm:ml-2 space-y-1 mb-1 sm:space-y-1">
            {cardData?.map((card) => (
              <div
                key={card?.id}
                className={`first:mt-1 hover:cursor-pointer w-24.6 relative group ${
                  selectedDiv === card?.id
                    ? "outline outline-offset-2 outline-2 rounded-sm"
                    : ""
                } `}
                onClick={() => divCardHandler(card)}
              >
                {card?.brand === "visa" ? (
                  <VisaCard
                    last4={card?.last4}
                    date={
                      card?.expiryMonth +
                      "/" +
                      card?.expiryYear.toString().slice(-2)
                    }
                  />
                ) : (
                  <MasterCard
                    last4={card?.last4}
                    date={
                      card?.expiryMonth +
                      "/" +
                      card?.expiryYear.toString().slice(-2)
                    }
                  />
                )}
                <div
                  className="absolute top-0 right-0 border-none p-0 opacity-0 group-hover:opacity-100 transition-opacity"
                  onClick={() => {
                    cardClickHandler(card);
                  }}
                  style={{ right: "-10px", top: "-10px", zIndex: 10 }}
                >
                  <img src={Delete} alt="Delete Icon" className="w-4" />
                </div>
              </div>
            ))}

            <div onClick={handleForm}>
              <AddCard title={"Add Card"} />
            </div>
          </div>

          <div>
            {showCheckBox && (
              <div className="">
                <div className="ml-2">
                  <Checkbox
                    description="Set As Primary Card"
                    onChecked={(value) => {
                      setCheckValue(value);
                    }}
                  />
                </div>
                <div className="flex justify-end space-x-4 ml-1 mr-2 mb-2">
                  <Button
                    title="Save"
                    className="bg-primaryPurple w-15.8 h-3.4"
                    onClick={primaryClickHandler}
                  />
                </div>
              </div>
            )}
            {showForm && (
              <div className="">
                <Form onFinish={onFinish} form={form}>
                  <div className="xl:grid xl:grid-cols-4 sm:grid sm:grid-cols-1 gap-3 md:grid md:grid-cols-2 mt-2 ml-2 mr-2">
                    <Form.Item
                      name="holderName"
                      rules={[
                        {
                          required: true,
                          message: "Holder Name is required",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Holder Name"
                        className="bg-inputFieldGrey mr-2 w-full h-5.4 placeholder-placeHolderGrey"
                      />
                    </Form.Item>
                    <Form.Item
                      name="cardNumber"
                      className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center"
                    >
                      <div className="ml-1">
                        <CardNumberElement />
                      </div>
                    </Form.Item>
                    <Form.Item
                      name="cardExpiry"
                      className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center"
                    >
                      <div className="ml-1 text-primaryBlue">
                        <CardExpiryElement />
                      </div>
                    </Form.Item>
                    <Form.Item
                      name="cardCVV"
                      className="bg-inputFieldGrey h-5.4 w-full rounded-sm flex flex-col justify-center"
                    >
                      <div className="ml-1">
                        <CardCvcElement />
                      </div>
                    </Form.Item>
                  </div>

                  <div className="flex justify-end space-x-4 ml-1 mr-2 mb-2">
                    <Button
                      title="Save"
                      className="bg-primaryPurple w-15.8 h-3.4"
                      loading={loader}
                      htmlType="submit"
                    />
                  </div>
                </Form>
              </div>
            )}
          </div>
        </Card>

        {/* Billing Address Card */}
        <Card className="m-2 shadow-md">
          <p className="ml-2 text-primaryPurple font-medium flex sm:justify-start justify-center">
            Billing Address
          </p>
          {userData?.response?.billingAddress && (
            <div className="border-solid border-inputFieldGrey rounded-sm justify-center items-center p-2 lg:col-span-2 lg:px-5">
              <Form
                onFinish={onBillingChange}
                initialValues={{
                streetAddress: userData?.response?.billingAddress?.streetAddress || "",
                State: userData?.response?.billingAddress?.state || "",
                city: userData?.response?.billingAddress?.city || "",
                zipCode: userData?.response?.billingAddress?.zipCode || ""
              }}
            >
              <div className="w-full xl:grid xl:grid-cols-4 xl:gap-2 xl:content-start">
                <Form.Item name="streetAddress">
                  <Input
                    className={"w-full hover:border-primaryBlue h-5.4 "}
                    placeholder="Street Address"
                  />
                </Form.Item>
                <Form.Item
                  name="State"
                  className="w-full bg-inputFieldGrey rounded-md"
                >
                  <Dropdown
                    defaultValue={userData?.response?.billingAddress?.state}
                    placeholder={"State"}
                    data={usStates?.states}
                  />
                </Form.Item>
                <Form.Item
                  name="city"
                  className="w-full bg-inputFieldGrey rounded-md"
                >
                  <Input
                    className={"w-full hover:border-primaryBlue h-5.4 "}
                    placeholder="City"
                  />
                </Form.Item>

                <Form.Item
                  name="zipCode"
                  className="w-full"
                  rules={[
                    {
                      pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                      message: "Please enter a positive number",
                    },
                  ]}
                >
                  <InputNumber
                    className={
                      "w-full hover:border-primaryBlue flex items-center h-5.4 "
                    }
                    type="number"
                    controls={false}
                    placeholder="Zip Code"
                  />
                </Form.Item>
              </div>
              <Form.Item className="w-full justify-center flex lg:justify-end">
                <Button
                  color="#7B61FF"
                  title="Save"
                  htmlType="submit"
                  className="w-19"
                  loading={bloader}
                />
              </Form.Item>
            </Form>
          </div>)}
        </Card>

        {isModalOpen && (
          <DeleteMemberModal
            title="Delete Card"
            text="Are you sure you want to delete card?"
            onCancel={hideModal}
            onOk={YesClickHandler}
          />
        )}
      </div>
    </div>
  );
};
export default EditPaymentMethod;
